<div class="c-plan-table01__col-inner">
  <!-- [3-11] 座席番号 -->
  <div
    class="c-plan-table01__col-item c-plan-table01__col-item--fs16 c-plan-table01__col-item--em"
    *ngFor="let seatNumber of getSeatNumber(flight.id, traveler.id)"
  >
    {{ seatNumber }}
  </div>

  <!-- [3-12] 座席属性 -->
  <div
    class="c-plan-table01__col-item c-plan-table01__col-item--fs16 c-plan-table01__col-item--blue"
    *ngIf="getSeatAttributes(flight.id, traveler.id); let seatAttributes"
  >
    {{ seatAttributes }}
  </div>

  <!-- [3-15] 座席ステータス -->
  <div
    class="c-plan-table01__col-item c-plan-table01__col-item--fs16 c-plan-table01__col-item--fs16"
    *ngIf="getSeatServiceStatus(flight, traveler); let seatServiceStatus"
    [innerHTML]="seatServiceStatus | staticMsg"
  ></div>
</div>
